module App.Classes {
    export class LoadingInterceptor {
        public static Factory($rootScope: App.Interfaces.IAppRootScope) {
            return new LoadingInterceptor($rootScope);
        }

        constructor(private $rootScope: App.Interfaces.IAppRootScope) {
        
        }

        public request = (config: ng.IRequestConfig) => {
            config.timeout = 12000;
            this.$rootScope.$broadcast(Constants.broadcast.loading.show);
            return config;
        }

        public response = (response) => {
            this.$rootScope.$broadcast(Constants.broadcast.loading.hide);
            return response;
        }

        public requestError = (rejection) => {
            this.$rootScope.$broadcast(Constants.broadcast.loading.hide);
            return rejection;
        }

        public responseError = (rejection) => {
            this.$rootScope.$broadcast(Constants.broadcast.loading.hide);
            return rejection;
        }
    }
}